import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompetencyData } from 'src/app/Models/organizationModel.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Partnership } from './competency/partnership-creation-component/partnership-creation-component.component';

@Injectable({
  providedIn: 'root'
})

export class CompetenciesService {
  check: boolean = false
  private profileStatus = new BehaviorSubject<number>(null)
  private competencyName = new BehaviorSubject<string>("")
  private serviceline = new BehaviorSubject<number>(1)
  competencyName$ = this.competencyName.asObservable();
  profileStatus$ = this.profileStatus.asObservable();
  serviceline$ = this.serviceline.asObservable();
  private SubcompetencyName = new BehaviorSubject<string>("")
  SubcompetencyName$ = this.SubcompetencyName.asObservable();
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  getCheckFlag(): boolean {
    return this.check;
  }
  public toggleFlag() {
    this.check = !this.check;
  }
  private apiUrl = environment.apiUrl;
  private apiUrl2 = environment.GSDapiUrl;
  constructor(private http: HttpClient) { }

  private serviceIdSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  serviceId$ = this.serviceIdSubject.asObservable();

  updateServiceId(serviceId: number) {
    this.serviceIdSubject.next(serviceId);
  }

  public getSubCompetencies(id: number) {
    const url = this.apiUrl + 'Competency/' + id + '/subcompetencies';
    return this.http.get<any>(url, this.httpOptions);
  }
  public getCompetencyByid(id: number) {
    const url = this.apiUrl + 'Competency/' + id + '/subcompetencies';
    return this.http.get<any>(url, this.httpOptions);
  }
  public getSubCompetenciesForDropDowns(compId) {

    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetServices(compId) {
    const url = `${this.apiUrl}Competency/GetServiceAreasByCompetencyId?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getCompetencies() {
    const url = this.apiUrl + 'Competency/competencies';
    return this.http.get<any>(url, this.httpOptions);
  }
  public getCompetenciesData() {
    const url = this.apiUrl + 'Competency/GetCompetenciesData';
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetCompetencyLevelCounts(compId) {
    const url = `${this.apiUrl}Profile/GetCompetencyLevelCounts?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }


  public GetResourceWidgetCount(compId, serviceLineId, detailed) {
    const url = `${this.apiUrl}Competency/resource-count?competencyId=${compId}&serviceLineId=${serviceLineId}&detailed=${detailed}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public GetNoCompetencyData(search, from, size, statusList: Array<string>=[], 
    competencySubCompetencyPairs: { competencyId: number, subCompetencyId: number }[] = []) { //=["unassigned", "requested"]
    var params = new HttpParams()
      .set('searchText', search)
      .set('from', from.toString())
      .set('size', size.toString());
    statusList.forEach(status => {
      params = params.append('status', status);
    });
    const requestBody = competencySubCompetencyPairs;
    const url = `${this.apiUrl}Competency/GetNoCompetencyEmployeeIds`;
    return this.http.post<any>(url, requestBody, { params, headers: this.httpOptions.headers });
  }
  public getExistingCompetencyEmployees(from: number, size: number, searchText: string = '') {
    let params = new HttpParams()
      .set('searchText', searchText)
      .set('from', from.toString())
      .set('size', size.toString());
  
    if (searchText) {
      params = params.set('searchText', searchText);
    }
  
    const url = `${this.apiUrl}Competency/GetExistingCompetencyEmployees`;
    return this.http.get<any>(url, { params, headers: this.httpOptions.headers });
  }
  
  public GetSubCOEFilterData() {
    const url = `${this.apiUrl}Competency/GetUniqueSubCompetenciesForFilter`;
    return this.http.get<any>(url);
  }

  // public GetCOEFilterData() {
  //   const url = `${this.apiUrl}Competency/GetUniqueRequestedCompetenciesWithCOE`;
  //   return this.http.get<any>(url);
  // }

  public GetNoCompetencyEmployeesForExport(search, from, size) {
    const url = `${this.apiUrl}Competency/GetNoCompetencyEmployeesForExport?search=${search}&from=${from}&size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public ApproveEmployeesCompetencies(ids: Array<number>) {
    const url = `${this.apiUrl}ManagerCompetencyAndSubCompetency/Approve`;
    let params = new HttpParams();
    ids.forEach(id => {
      params = params.append('employeeCompetencyRequestIds', id.toString());
    });
    return this.http.post(url,{}, {params});
  }

  public DeclineEmployeesCompetencies(ids: Array<number>) {
    const url = `${this.apiUrl}ManagerCompetencyAndSubCompetency/Reject`;
    let params = new HttpParams();
    ids.forEach(id => {
      params = params.append('employeeCompetencyRequestIds', id.toString());
    });
    return this.http.post(url,{}, {params});
  }

  public GetServiceAreaLevelCounts(compId) {
    const url = `${this.apiUrl}Profile/GetServiceAreaLevelCounts?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public GetOthersWidgetCount(compId, subcompId) {
    const url = `${this.apiUrl}Tool/GetOthersWidgetCount?competencyId=${compId}&subcompetencyId=${subcompId}`;
    return this.http.get<any>(url, this.httpOptions
    );
  }

  public GetTrainingsWidgetCount(compId, subcompId, startDate, endDate) {
    const url = `${this.apiUrl}TrainingSession/GetTrainingsCount?competencyId=${compId}&subCompetencyId=${subcompId}&startDate=${startDate}&endDate=${endDate}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetSettings(Id) {
    const url = `${this.apiUrl}Profile/GetSettingsById?userId=${Id}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public EditSetting(object) {
    const url = `${this.apiUrl}Profile/UpdateSettings`;
    return this.http.put<any>(url, object, this.httpOptions);
  }
  public GetResourceCount(compId, subcomp) {
    const url = `${this.apiUrl}Competency/GetCompetencyResourceCount?competencyId=${compId}&subCompetencyName=${subcomp}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public GetCompetencyInsightCount(compId, subcomp) {
    const url = `${this.apiUrl}Competency/GetAllCompetenciesWithCount?competencyId=${compId}&subCompetencyName=${subcomp}`;
    return this.http.get<any>(url, this.httpOptions)
  }


  public getOrgChartEmployeeshierarchy(compId, subcompId) {
    const url = `${this.apiUrl}Competency/GetCompetencyLeader?CompentencyId=${compId}&SubCompentencyName=${subcompId}`;
    return this.http.get<any>(url);
  }


  public GetEmployeesCountByCompetency(searchText: any) {
    const url = `${this.apiUrl}Profile/GetEmployeesCountByCompetency?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetResourceCountBySubCompetency(compId: any) {
    const url = `${this.apiUrl}Competency/GetResourceCountByCompetency?CompentencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public updateCompetencyLeaderHierarchy(updatedData: CompetencyData) {
    const url = `${this.apiUrl}Competency/AddCompentencyLeader`;
    return this.http.post(url, updatedData)


  }

  public AddCompetencyinfo(requestData: any) {
    const url = `${this.apiUrl}Competency/AddCompetencyInfo?competencyName=${requestData.selectedCompetency}&subCompetencyName=${requestData.selectedSubCompetencies}`;
    return this.http.post(url, requestData.employeesList)
  }

  setProfileStatus(value) {
    this.profileStatus.next(value);
  }
  setCompetencyName(value) {
    this.competencyName.next(value);
  }
  setServiceLine(value) {
    this.serviceline.next(value);
  }
  setsubcompname(value: any) {
    this.SubcompetencyName.next(value);
  }

  public GetCertificateWidgetCount(compId, serviceLineId) {
    const url = `${this.apiUrl}Competency/GetCertificateCountByServiceLine?competencyId=${compId}&serviceLine=${serviceLineId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GettrainingCount(compId, serviceLineId) {
    const url = `${this.apiUrl2}Training/GetTrainingsCount?competencyId=${compId}&serviceLineId=${serviceLineId}`;
    return this.http.get<any>(url, this.httpOptions)
  }
  public GetOthersCount(compId, subcompId) {
    const url = `${this.apiUrl2}Tool/getToolsCount?competencyId=${compId}&subCompetencyId=${subcompId}`;
    return this.http.get<any>(url, this.httpOptions)
  }
  public SetSettingById(employeeId, kpIs, widgets) {
    const url = `${this.apiUrl}Profile/UpdateSettings`
    return this.http.put<any>(url, { employeeId, kpIs, widgets }, this.httpOptions);
  }
  public getSettingsById(employeeId) {
    const url = `${this.apiUrl}Profile/GetSettingsById?userId=${employeeId}`
    return this.http.get<any>(url, this.httpOptions);

  }
  public getPartnershipdetails() {
    const url = `${this.apiUrl}Competency/GetPartnershipDetails`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public postPartnershipdetails(data: Partnership) {
    const url = `${this.apiUrl}Competency/AddorUpdatePartnershipDetails`;
    return this.http.post<any>(url, data);
  }
  public deletePartnershipdetails(id: string) {
    const url = `${this.apiUrl}Competency/DeletePartnershipDetailsById?id=${id}`;
    return this.http.delete<any>(url, this.httpOptions);
  }

  getCMFMentorDashboard() {
    const url = `${this.apiUrl}TrainingSession/GetCMFMentorDashboard`;
    return this.http.get<any>(url, this.httpOptions);
  }
}
